import globalApi from "../../app/GlobalApi";
import { setcheckedCategory } from "./projectFilterSlice";






const projectsApi = globalApi.injectEndpoints({
  endpoints: (builder) => ({
  
 
    getProject: builder.query({
        
    query: () => ({
      url: `/projects`,
      method: 'GET',
    }),
    async onQueryStarted(arg, { queryFulfilled, dispatch }) {
      const projects = await queryFulfilled;
     
      if (projects?.data?.length > 0) {
          
     
         dispatch(setcheckedCategory([...projects?.data.map(p=>p.id)]))

         
      }
  },

}),
})

})
export const { useGetProjectQuery} = projectsApi;
